<template>
<div class="container-base"
     v-once>
  <div class="pages page-static">
    <div class="page-static-inner">
      <h1 style="font-size: 140%;">【개인정보보호정책】</h1>
      <p>주식회사 Yagish(이하 「당사」라 함.)는 개인정보 보호의 중요성을 철저히 인식하고, 법령 기타 규범을 준수하며 이용자의 중요한 개인정보의 취급에는 세심한 주의를 기울이고 있습니다. 따라서 당사는  이용자에 관한 정보를 어떻게 취득, 이용, 공개, 이전 및 보존하는지에 대해 규정하는 개인정보보호방침을 알려드립니다. 또한 당사 서비스 등에 대해서는 개별적으로 개인정보보호방침을 게재하는 경우가 있습니다.
      </p>
      <h2>1. 개인정보 수집 및 이용</h2>
      <pre>당사는 업무상 개인정보를 수집하는 경우 이용목적을 명확히 한 후에 이를 수행합니다. 또한 개인정보의 이용 시에는, 그 이용목적의 범위내에서만 적절히 수집합니다.</pre>
      <h2>2. 제3자에게의 제공, 위탁</h2>
      <pre>당사는 수집한 개인정보를 사전의 승인 없이는 어떠한 제3자에게도 공유, 제공하지 않습니다. 다만, 이하의 경우를 제외합니다.
      ①법령에 근거하는 경우
      ②인간의 생명, 신체, 재산의 보호를 위해서 필요로 하는 경우로 이용자의 동의를 얻는 것이 곤란한 경우
      ➂공중보건의 향상이나 아동의 건전한 육성의 추진을 위해서 필요할 경우로 이용자의 동의를 얻는 것이 곤란한 경우
      ➃국가기관 또는 지방공공단체 또는 그 위탁을 받은 자가 법령이 정하는 사무를 수행하는 것에 대해 협력할 필요가 있는 경우로 이용자의 동의를 얻음으로써 해당 사무의 수행에 지장을 미칠 우려가 있는 경우
      ⑤수집, 이용목적의 달성에 필요한 범위에서 개인정보의 취급을 위탁하는 경우
      ⑥합병 그 외의 사유에 의한 사업승계에 수반해 개인정보를 제공하는 경우, 또는 업무 위탁업체에 개인정보의 취급을 위탁하는 경우에는 기밀유지계약 등에 의해 해당 위탁업체에 개인정보보호를 의무화하는 것과 동시에, 해당 위탁업체가 철저하게 개인정보를 취급하도록 감독합니다.
      </pre>
      <h2>3. 개인의 권리 존중</h2>
      <pre>당사는 개인정보에 관한 정보주체의 권리를 존중하고 정보주체 본인으로부터 자기의 개인정보 공지, 수정, 이용정지가 요구가 있을 시 이에 대응합니다.</pre>
      <h2>4.안전성, 정확성 확보</h2>
      <pre>당사는 개인정보의 안전성과 정확성을 확보하기 위해, 부정한 액세스, 분실, 훼손, 변조 및 누출 등을 방지하기 위한 정보기술 대책을 강구합니다.</pre>
      <h2>5.법령 및 규범의 준수</h2>
      <pre>당사는 개인정보의 취급에 관하여 「개인정보보호에 관한 법률」 및 관련 법령 및 기타 규범을 준수합니다.</pre>
      <h2>6. 사내의 주지 및 감독</h2>
      <pre>이용자의 개인정보의 안전성을 유지하기 위해 당사는 직원에게 개인정보보호 및 안전성 가이드라인을 전달하여 사내에서의 개인정보처리방침을 철저히 준수하고 있습니다.</pre>
      <pre>
      개인정보보호에 관한 문의 창구
      담당부서 및 연락처, 이메일, 사이트 문의 안내 등 기재
      2-3-12 Ebisu Nishi, Shibuya-ku, Tokyo, Japan
      주식회사 Yagish
      support@yagish.jp
      </pre>

    </div>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () {}
}
</script>
